import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { sepaActions } from '../+state/sepa/sepa.actions';
import { sepaFeature } from '../+state/sepa/sepa.reducers';
import { ServedByOption, ServedByOptionType } from '../entities/served-by-option.entity';

@Injectable({ providedIn: 'root' })
export class SepaFacade {
  readonly #store = inject(Store);

  public hasSepa$: Observable<boolean> = this.#store.select(sepaFeature.selectHasSepa);
  public loading$: Observable<boolean> = this.#store.select(sepaFeature.selectLoading);
  public errorMessage$: Observable<string> = this.#store.select(sepaFeature.selectErrorMessage);
  public options$: Observable<ServedByOption[]> = this.#store.select(sepaFeature.selectOptions);
  public selectedOption$: Observable<ServedByOption> = this.#store.select(sepaFeature.selectSelectedOption);
  public displaySuccessHint$: Observable<boolean> = this.#store.select(sepaFeature.selectDisplaySuccessHint);

  public loadHasSepa = () => this.#store.dispatch(sepaActions.loadHasSepa());
  public toggleSepa = (useDirectDebit: boolean) => this.#store.dispatch(sepaActions.toggleSepa({ useDirectDebit }));
  public loadOptions = () => this.#store.dispatch(sepaActions.loadOptions());
  public changeOption = (optionType: ServedByOptionType) => this.#store.dispatch(sepaActions.changeOption({ optionType }));
  public resetOptions = () => this.#store.dispatch(sepaActions.resetOptions());
}
